import { getMicroserviceBaseContext } from '../../constants/api-routing';

const summarizationContext = getMicroserviceBaseContext('summarization');

export const SUMMARIZATION_SERVICE = {
    getSummaryResponseOverlap: `${summarizationContext}summarization_chat_response_overlap`,
    sendSummaryChatResponse: `${summarizationContext}create_summarization_chat_history`,
    getSummaryChatDetails: `${summarizationContext}get_summarization_chat_history_with_summary_by_session_id`,
    getDownloadUrl: `${summarizationContext}summarization_generate_reference_doc_url`,
    summarizerFileUpload: `${summarizationContext}summarize_file`,
    summarizerTextContent: `${summarizationContext}summarize_text`,
    summarizerQandA: `${summarizationContext}summarizer_qna`,
    getSummaryFeedbackDataFileOrText: `${summarizationContext}get_summary_feedback_by_document_summary_id`,
    getSummaryFeedbackDataQNA: `${summarizationContext}get_summary_qna_conversation_feedback_by_chat_history_id`,
    createFeedbackDataFileOrText: `${summarizationContext}create_summary_feedback`,
    createFeedbackDateForQNA: `${summarizationContext}create_summary_qna_conversation_feedback`,
    updateSummaryFeedbackDataFileOrText: `${summarizationContext}update_summary_feedback_by_summary_id`,
    updateSummaryFeedbackDataQNA: `${summarizationContext}update_summary_qna_conversation_feedback_by_history_id`,
    summarizeFileBackground: `${summarizationContext}summarize_file_background`,
}
